const ContactUs = () => {
    return (
      <div className="contact-container">
        <form className="contact-form">
          <h2>Contact Us</h2>
  
          <div className="input-group">
            <input type="text" required />
            <label>Name</label>
          </div>
  
          <div className="input-group">
            <input type="email" required />
            <label>Email</label>
          </div>
  
          <div className="input-group">
            <textarea required></textarea>
            <label>Message</label>
          </div>
  
          <button type="submit" className="submit-btn">Send Message</button>
        </form>
      </div>
    );
  };
  
  export default ContactUs;